document.addEventListener('DOMContentLoaded', function () {
  const hamburger = document.querySelector('.hamburger');
  const mobileNav = document.querySelector('.mobile-nav');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', () => {
      mobileNav.classList.toggle('open');
      const spans = hamburger.querySelectorAll('span');
      spans[0].style.transform = mobileNav.classList.contains('open') ? 'rotate(45deg) translate(5px, 5px)' : '';
      spans[1].style.opacity = mobileNav.classList.contains('open') ? '0' : '1';
      spans[2].style.transform = mobileNav.classList.contains('open') ? 'rotate(-45deg) translate(5px, -5px)' : '';
    });
  }
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) { setTimeout(() => entry.target.classList.add('visible'), i * 80); observer.unobserve(entry.target); }
      });
    }, { threshold: 0.1 });
    reveals.forEach(el => observer.observe(el));
  }
  document.querySelectorAll('.filter-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });
  const bar = document.querySelector('.announcement-bar');
  const closeBar = document.querySelector('.close-bar');
  if (closeBar && bar) closeBar.addEventListener('click', () => bar.remove());
  const header = document.querySelector('.site-header');
  if (header) window.addEventListener('scroll', () => { header.style.boxShadow = window.scrollY > 10 ? '0 4px 24px rgba(0,0,0,0.3)' : ''; });
  function animateCounter(el, target, duration) {
    let start = 0;
    const step = target / (duration / 16);
    const timer = setInterval(() => {
      start += step;
      if (start >= target) { el.textContent = target.toLocaleString('en-IN') + (el.dataset.suffix || ''); clearInterval(timer); }
      else el.textContent = Math.floor(start).toLocaleString('en-IN') + (el.dataset.suffix || '');
    }, 16);
  }
  const statNums = document.querySelectorAll('.stat-num[data-target]');
  if (statNums.length) {
    const statsObs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) { animateCounter(entry.target, parseInt(entry.target.dataset.target), 1200); statsObs.unobserve(entry.target); }
      });
    }, { threshold: 0.5 });
    statNums.forEach(el => statsObs.observe(el));
  }
});